<template>
  <v-container
    fluid
    class="d-flex flex-column justify-center"
  >
    <v-text-field
      v-model="customer.name"
      dense
      lable="Customer Name"
      prepend-icon="mdi-account-circle"
      filled
      disabled
      readonly
    />
    <v-text-field
      dense
      :value="customer.email"
      lable="Email"
      prepend-icon="mdi-email"
      filled
      disabled
      readonly
    />
    <v-text-field
      dense
      :value="description"
      lable="Subscription"
      disabled
      filled
      readonly
      persistent-hint
      :prepend-icon="(item||{}).currency_icon"
      hint="Subscription"
    />
    <v-textarea
      dense
      height="70"
      disabled
      no-resize
      :value="`${card.brand} ....${card.last4}\nExpires: ${card.exp_month}/${card.exp_year}`"
      lable="Credit Card"
      prepend-icon="mdi-credit-card"
      filled
      readonly
    />
 
    <v-badge
      bordered
      icon="mdi-test-tube"
      :value="customer.livemode === false"
      offset-y="10"
      offset-x="10"
      left
      color="secondary"
    >
      <v-btn
        text
        block
        dark
        class="primary"
        :loading="busy"
        :disabled="!paymentMethodID || !(customer || {}).id || !description"
        @click="createSubscription"
      >
        create subscription
      </v-btn>
    </v-badge>

    <mb-content
      name="checkout_info"
      style="font-size: smaller; line-height: initial;"
    />
  </v-container>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: ()=>{return {}}
    },
    step: {
      type: Number,
      default: ()=>0 
    },
  },
  data(){
    return {
      busy: false,
      customer: {},
      paymentMethods: []
    }
  },
  computed: {
    description(){
      let item = this.item || {}
      return `${item.total} ${item.interval}`},
    paymentMethodID(){
      return (this.paymentMethod||{}).id
    },
    paymentMethod(){
      return (this.paymentMethods||[]).filter(m=>{
        return !!m.default
      })[0]
    },
    card(){
      return (this.paymentMethod||{}).card || {}
    },
  },
  watch:{
    step(){this.fetch()}
  },
  mounted(){
    this.fetch()
  },
  methods:{
    async fetch(){
      const stripe = await this.api.get('/stripe/account')
      this.customer = stripe && stripe.customer || {}
      this.paymentMethods = stripe && stripe.payment_methods || []
    },

    async createSubscription(){
      this.busy = true
      let data = await this.api.post('/stripe/create_subscription', this.item)
      if (data && data.id && data.object == 'subscription') {
        this.$emit('success')
      }
      this.busy = false
    }
  },
}
</script>